import { parseApproximateLocation } from 'shared/library/approximate-location';

export type FetchApproximateLocationOptions = {
  fetchFn?: typeof fetch;
  timeoutInMs?: number;
};

export async function fetchApproximateLocation({
  fetchFn = fetch,
  timeoutInMs = 2500,
}: FetchApproximateLocationOptions = {}) {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), timeoutInMs);
  try {
    const response = await fetchFn('/api/approximate-location', { signal: controller.signal });
    return response.ok ? parseApproximateLocation(await response.json()) : null;
  } catch {
    return null;
  } finally {
    clearTimeout(timer);
  }
}
